/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A collection of serializer extensions, which allow for:
 * 
 * * Blacklisting fields through an "exclude" context variable
 * * Whitelisting fields through an "only" context variable
 * * Expanding related fields through an "expand" context variable
 * * Other helper methods
 * 
 * Blacklisting and whitelisting takes precedence over expanding, and can
 * be used in combination with one another.
 * @export
 * @interface APIPatchedMaterialRequest
 */
export interface APIPatchedMaterialRequest {
    /**
     * 
     * @type {string}
     * @memberof APIPatchedMaterialRequest
     */
    name?: string;
}

/**
 * Check if a given object implements the APIPatchedMaterialRequest interface.
 */
export function instanceOfAPIPatchedMaterialRequest(value: object): value is APIPatchedMaterialRequest {
    return true;
}

export function APIPatchedMaterialRequestFromJSON(json: any): APIPatchedMaterialRequest {
    return APIPatchedMaterialRequestFromJSONTyped(json, false);
}

export function APIPatchedMaterialRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIPatchedMaterialRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function APIPatchedMaterialRequestToJSON(value?: APIPatchedMaterialRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
    };
}

